import React from "react";
import styled from "styled-components";
import { Radius, Spacing, form, transparentize } from "@glossy";
import Text from "@ui-kit/form/text";

export interface IProps {
  filteredValue: { value: string; color: string };
  placeholder: string;
  index: number;
  onClickColor: () => void;
  onChangeFilteredValue: (index: number, value: string, color: string) => void;
}

const Root = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.Small};
`;

const ColorInput = styled.div`
  cursor: pointer;
  border-radius: ${Radius.Small};
  padding: ${Spacing.ExtraSmall};
  background-color: ${(props) => transparentize(0.85, form(props, "primary"))};
`;

const ColorSquare = styled.div`
  border-radius: ${Radius.Small};
  width: 24px;
  height: 24px;
`;

const defaultColors = ["#3987C3", "#EFB136", "#A73A9C"];

export default function FilteredValue({
  filteredValue,
  index,
  placeholder,
  onClickColor,
  onChangeFilteredValue,
}: IProps) {
  const color = filteredValue?.color || defaultColors[index];
  const value = filteredValue?.value || "";

  return (
    <Root>
      <ColorInput onClick={onClickColor}>
        <ColorSquare
          style={{ backgroundColor: color, height: 24, width: 24 }}
        />
      </ColorInput>
      <Text
        value={value}
        onChange={(value) => onChangeFilteredValue(index, value, color)}
        placeholder={placeholder}
        variant="primary"
      />
    </Root>
  );
}
